import 'slick-carousel';

const handleSlider = (slider = '.js-slider') => {
  const $slider = $(slider);
  const slidesShow = $slider.data('slides-show');
  const sliderNav = $slider.data('slider-nav');
  const sliderDots = $slider.data('slider-dots');
  const autoplay = $slider.data('autoplay');

  const config = {
    slidesToShow: slidesShow || 1,
    slidesToScroll: slidesShow || 1,
    dots: sliderDots || false,
    arrows: sliderNav || false,
    infinite: true,
    autoplay: autoplay || false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          variableWidth: true
        }
      }
    ]
  };

  $slider.find('.slider__slides')
    .not('.slick-initialized')
    .slick(config);
}

export default handleSlider;

$('.js-slider').each(function() {
  const $this = $(this);
  const $tabParent = $this.closest('.tab');

  if ($tabParent.length > 0) {
    if ($tabParent.hasClass('is-current')) {
      handleSlider($this);
    }
  } else {
    handleSlider($this);
  }
});

$(window).on('shopify:section:load', function(event) {
  handleSlider();
});
